import { TiptapEmbedWebComponent } from '@vp/tiptap-embed';
import type { App } from 'vue';

export const tiptapEmbedsPlugin = {
  install: (_app: App) => {
    if (!customElements.get('iframe-embed')) {
      customElements.define('iframe-embed', TiptapEmbedWebComponent);
    }
  },
};
